import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Segment, Table, Label} from 'semantic-ui-react';

class InventoryOnOrderSegment extends React.PureComponent {
    getOutstanding = (type, quantity) => {
        if (type === 'Customer Order' || type === 'Vendor Return') {
            return quantity * -1
        }
        if (type === 'Vendor Order' || type === 'Customer Return') {
            return quantity;
        }
    }

    totalOutstanding = () => {
        const {list} = this.props;
        let total = 0;
        _.each(list, i => {
            total = total + this.getOutstanding(i.type,  i.outstanding);
        });
        return total;
    }
    
    render() {
        const {list} = this.props;
        return (
            <Segment raised>
                <Label color='teal' ribbon>
                    On Orders
                </Label>
                <div className="row" style={{marginTop: '5px'}}>
                    <div className="col-md-12">
                        <Table compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Order #</Table.HeaderCell>
                                    <Table.HeaderCell>Order Type</Table.HeaderCell>
                                    <Table.HeaderCell>Order Status</Table.HeaderCell>
                                    <Table.HeaderCell>Outstanding Qty</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {list.map(item => {
                                    return <Table.Row key={item.order_line_id}>
                                        <Table.Cell>
                                            {item.so}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {item.type}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {item.status}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {this.getOutstanding(item.type, item.outstanding)}
                                        </Table.Cell>
                                    </Table.Row>
                                })}
                                <Table.Row>
                                    <Table.Cell colSpan={3}>
                                        Total
                                    </Table.Cell>
                                    <Table.Cell>
                                        {this.totalOutstanding()}
                                    </Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                    </div>
                </div>
            </Segment>
        )
    }
}

InventoryOnOrderSegment.propTypes = {
    list: PropTypes.array.isRequired
};

export default InventoryOnOrderSegment


// WEBPACK FOOTER //
// ./src/components/utils/others/InventoryOnOrderSegment.js